var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRepeat(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 3C12 2.44772 12.4477 2 13 2C18.5228 2 23 6.47715 23 12C23 17.5228 18.5228 22 13 22C8.42545 22 4.56832 18.9283 3.37862 14.735L2.83216 15.5547C2.5258 16.0143 1.90493 16.1384 1.44541 15.8321C0.985877 15.5257 0.861704 14.9049 1.16806 14.4453L3.15609 11.4633C3.16348 11.4517 3.17111 11.4402 3.17897 11.429L3.72276 10.6133L4.54384 11.1607C4.55064 11.1651 4.55738 11.1696 4.56407 11.1742L7.55481 13.168C8.01434 13.4743 8.13851 14.0952 7.83216 14.5547C7.5258 15.0143 6.90493 15.1384 6.44541 14.8321L5.26354 14.0442C6.16689 17.4722 9.28825 20 13 20C17.4183 20 21 16.4183 21 12C21 7.58172 17.4183 4 13 4C12.4477 4 12 3.55228 12 3Z",
    fill: "#293042"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRepeat);
export default __webpack_public_path__ + "static/media/repeat.e3b57248e0debd93eb860f958cb786d3.svg";
export { ForwardRef as ReactComponent };